module.exports = __webpack_public_path__ + "img/zoek-icon.964fe93db74341c3e6c5d094c2cdb6e5.svg";